import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { akitaConfig, enableAkitaProdMode, persistState } from '@datorama/akita';
import rg4js from 'raygun4js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

akitaConfig({ resettable: true });
persistState({ storage: sessionStorage });

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
}

if (!(window as unknown as { cluxUnsupportedBrowser?: boolean }).cluxUnsupportedBrowser) {
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(),
      importProvidersFrom(AppModule),
    ]
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error(error);
    rg4js('send', { error });
  });
}
